module.exports = __webpack_public_path__ + "img/linkend.4f7609f.jpg";